(function () {
  'use strict';

  var TERMS = [
    {
      tag: 'widerruf',
      id: 'terms-widerruf',
      title: 'Digitale Inhalte',
      text: 'F\u00fcr digitale Produkte: Ich stimme ausdr\u00fccklich zu, dass vor Ablauf der Widerrufsfrist mit der Ausf\u00fchrung des Vertrags begonnen wird. Mir ist bekannt, dass mit Beginn der Ausf\u00fchrung mein Widerrufsrecht erlischt.',
      errorLabel: 'Bitte akzeptiere die Widerrufsbedingungen'
    },
    {
      tag: 'lernapp',
      id: 'terms-lernapp',
      title: 'Theoriesteine to go - Nutzungsbedingungen',
      text: 'Ich akzeptiere die Theoriesteine to go - <a href="https://www.flattersatz.at/theoriesteine-to-go-nutzungsbedingungen/" target="_blank" rel="noopener">Nutzungsbedingungen</a> &amp; <a href="https://www.flattersatz.at/theoriesteine-to-go-datenschutzinformation/" target="_blank" rel="noopener">Datenschutzrichtlinien</a>',
      errorLabel: 'Bitte akzeptiere die Theoriesteine to go - Nutzungsbedingungen & Datenschutzrichtlinien'
    },
    {
      tag: 'klassenzimmer',
      id: 'terms-klassenzimmer',
      title: 'Theoriesteine Klassenzimmer Nutzungsbedingungen',
      text: 'Ich akzeptiere die Klassenzimmer - <a href="https://www.flattersatz.at/klassenzimmer-nutzungsbedingungen/" target="_blank" rel="noopener">Nutzungsbedingungen</a> &amp; <a href="https://www.flattersatz.at/klassenzimmer-datenschutzinformation/" target="_blank" rel="noopener">Datenschutzrichtlinien</a>',
      errorLabel: 'Ich akzeptiere die Klassenzimmer - Nutzungsbedingungen & Datenschutzrichtlinien'
    }
  ];

  var STORAGE_KEY = 'flattersatz_terms_accepted';

  function getAccepted() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {}; }
    catch (e) { return {}; }
  }

  function saveAccepted(accepted) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(accepted));
  }

  function fetchCartTags() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || cart.items.length === 0) return [];
        var handles = [];
        cart.items.forEach(function (item) {
          if (handles.indexOf(item.handle) === -1) handles.push(item.handle);
        });
        return Promise.all(handles.map(function (handle) {
          return fetch('/products/' + handle + '.js')
            .then(function (r) { return r.json(); })
            .then(function (p) { return p.tags || []; })
            .catch(function () { return []; });
        }));
      })
      .then(function (tagArrays) {
        var allTags = [];
        (tagArrays || []).forEach(function (tags) {
          tags.forEach(function (t) {
            var lower = t.toLowerCase().trim();
            if (allTags.indexOf(lower) === -1) allTags.push(lower);
          });
        });
        return allTags;
      });
  }

  function getRequiredTerms(cartTags) {
    return TERMS.filter(function (term) {
      return cartTags.indexOf(term.tag.toLowerCase()) !== -1;
    });
  }

  function renderTerms(requiredTerms, container) {
    container.innerHTML = '';
    if (requiredTerms.length === 0) return;

    var accepted = getAccepted();

    var wrapper = document.createElement('div');
    wrapper.className = 'conditional-terms';
    wrapper.innerHTML = '<style>' +
      '.conditional-terms { margin: 1.2rem 0; padding: 1.2rem 1.6rem; border: 2px solid #ffcb1c; border-radius: var(--buttons-radius, 4px); background: #fffdf0; }' +
      '.conditional-terms__heading { font-weight: 700; font-size: 1.4rem; margin-bottom: 1rem; color: rgb(var(--color-foreground)); padding-bottom: 0.6rem; border-bottom: 1px solid rgba(var(--color-foreground), 0.1); }' +
      '.conditional-terms__item { margin-bottom: 0.8rem; padding: 0.8rem 1rem; background: #fff; border: 1px solid rgba(var(--color-foreground), 0.08); border-radius: var(--buttons-radius, 4px); }' +
      '.conditional-terms__item:last-child { margin-bottom: 0; }' +
      '.conditional-terms__title { font-weight: 700; font-size: 1.25rem; margin-bottom: 0.4rem; color: rgb(var(--color-foreground)); }' +
      '.conditional-terms__label { display: flex; align-items: flex-start; gap: 0.8rem; cursor: pointer; font-size: 1.2rem; line-height: 1.5; color: rgba(var(--color-foreground), 0.85); }' +
      '.conditional-terms__label a { color: #000; font-weight: 600; text-decoration: underline; }' +
      '.conditional-terms__checkbox { margin-top: 0.2rem; min-width: 18px; min-height: 18px; accent-color: #ffcb1c; cursor: pointer; }' +
      '.conditional-terms__error { display: none; color: #cc0000; font-size: 1.2rem; font-weight: 600; margin-top: 0.8rem; padding: 0.7rem 1rem; border: 2px solid #cc0000; border-radius: var(--buttons-radius, 4px); background: #fff0f0; }' +
      '.conditional-terms__error.is-visible { display: block; }' +
      '@media screen and (max-width: 749px) { .conditional-terms { padding: 1rem; } .conditional-terms__item { padding: 0.7rem; } }' +
      '</style>';

    var heading = document.createElement('div');
    heading.className = 'conditional-terms__heading';
    heading.textContent = 'Bitte best\u00e4tige vor dem Checkout:';
    wrapper.appendChild(heading);

    requiredTerms.forEach(function (term) {
      var item = document.createElement('div');
      item.className = 'conditional-terms__item';

      var title = document.createElement('div');
      title.className = 'conditional-terms__title';
      title.textContent = term.title;

      var label = document.createElement('label');
      label.className = 'conditional-terms__label';

      var checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.className = 'conditional-terms__checkbox';
      checkbox.id = term.id;
      checkbox.checked = !!accepted[term.id];

      var text = document.createElement('span');
      text.innerHTML = term.text;

      label.appendChild(checkbox);
      label.appendChild(text);
      item.appendChild(title);
      item.appendChild(label);
      wrapper.appendChild(item);

      checkbox.addEventListener('change', function () {
        var acc = getAccepted();
        acc[term.id] = checkbox.checked;
        saveAccepted(acc);
        updateCheckoutState(requiredTerms);
      });
    });

    var errorDiv = document.createElement('div');
    errorDiv.className = 'conditional-terms__error';
    errorDiv.id = 'conditional-terms-error';
    wrapper.appendChild(errorDiv);

    container.appendChild(wrapper);
  }

  function allTermsAccepted(requiredTerms) {
    var accepted = getAccepted();
    return requiredTerms.every(function (term) {
      return !!accepted[term.id];
    });
  }

  function updateCheckoutState(requiredTerms) {
    var allAccepted = allTermsAccepted(requiredTerms);
    var errorEl = document.getElementById('conditional-terms-error');
    if (errorEl) {
      errorEl.classList.toggle('is-visible', false);
    }

    var checkoutBtns = document.querySelectorAll('#checkout, button[name="checkout"], .cart__checkout-button, .cart__dynamic-checkout-buttons button');
    checkoutBtns.forEach(function (btn) {
      if (allAccepted) {
        btn.removeAttribute('data-terms-blocked');
      } else {
        btn.setAttribute('data-terms-blocked', 'true');
      }
    });
  }

  function blockCheckout(requiredTerms) {
    var form = document.querySelector('form[action="/cart"]') || document.getElementById('cart');
    if (form) {
      form.addEventListener('submit', function (e) {
        var submitBtn = e.submitter;
        if (submitBtn && submitBtn.name === 'checkout' || (submitBtn && submitBtn.closest('.cart__dynamic-checkout-buttons'))) {
          if (!allTermsAccepted(requiredTerms)) {
            e.preventDefault();
            var unchecked = requiredTerms.filter(function (term) {
              return !getAccepted()[term.id];
            });
            var errorEl = document.getElementById('conditional-terms-error');
            if (errorEl) {
              errorEl.textContent = unchecked.map(function (t) { return t.errorLabel; }).join(' | ');
              errorEl.classList.add('is-visible');
            }
          }
        }
      });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.cart__dynamic-checkout-buttons button, [data-terms-blocked="true"]');
      if (btn && !allTermsAccepted(requiredTerms)) {
        e.preventDefault();
        e.stopPropagation();
        var unchecked = requiredTerms.filter(function (term) {
          return !getAccepted()[term.id];
        });
        var errorEl = document.getElementById('conditional-terms-error');
        if (errorEl) {
          errorEl.textContent = unchecked.map(function (t) { return t.errorLabel; }).join(' | ');
          errorEl.classList.add('is-visible');
        }
      }
    }, true);
  }

  function init() {
    var cartFooter = document.getElementById('main-cart-footer');
    if (!cartFooter) return;

    var container = document.createElement('div');
    container.id = 'conditional-terms-container';
    container.className = 'page-width';
    cartFooter.parentNode.insertBefore(container, cartFooter);

    fetchCartTags().then(function (cartTags) {
      var requiredTerms = getRequiredTerms(cartTags);
      if (requiredTerms.length === 0) return;

      renderTerms(requiredTerms, container);
      updateCheckoutState(requiredTerms);
      blockCheckout(requiredTerms);
    });
  }

  function initDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    var cartDrawerEl = document.getElementById('CartDrawer');
    if (!cartDrawerEl) return;

    function inject() {
      var old = drawer.querySelector('#conditional-terms-container-drawer');
      if (old) old.remove();

      fetchCartTags().then(function (cartTags) {
        var requiredTerms = getRequiredTerms(cartTags);
        if (requiredTerms.length === 0) return;

        // Guard: drawer might have been replaced again while we were fetching
        if (drawer.querySelector('#conditional-terms-container-drawer')) return;
        var drawerFooter = drawer.querySelector('.drawer__footer');
        if (!drawerFooter) return;

        var container = document.createElement('div');
        container.id = 'conditional-terms-container-drawer';

        var cartCtas = drawerFooter.querySelector('.cart__ctas');
        if (cartCtas) {
          drawerFooter.insertBefore(container, cartCtas);
        } else {
          drawerFooter.appendChild(container);
        }

        renderTerms(requiredTerms, container);

        var drawerForm = document.getElementById('CartDrawer-Form');
        if (drawerForm && !drawerForm._termsSetup) {
          drawerForm._termsSetup = true;
          drawerForm.addEventListener('submit', function (e) {
            if (!allTermsAccepted(requiredTerms)) {
              e.preventDefault();
              var errorEl = container.querySelector('.conditional-terms__error');
              if (errorEl) {
                errorEl.textContent = requiredTerms
                  .filter(function (t) { return !getAccepted()[t.id]; })
                  .map(function (t) { return t.errorLabel; })
                  .join(' | ');
                errorEl.classList.add('is-visible');
              }
            }
          });
        }
      });
    }

    // Sense ersetzt #CartDrawer.innerHTML beim Update — childList:true (kein subtree!)
    // so feuert der Observer bei Sense-Updates, aber NICHT wenn wir selbst Terms einfügen
    new MutationObserver(inject).observe(cartDrawerEl, { childList: true });

    inject();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); initDrawer(); });
  } else {
    init();
    initDrawer();
  }
})();
